import script from "./AlunosInativos.vue?vue&type=script&setup=true&lang=js"
export * from "./AlunosInativos.vue?vue&type=script&setup=true&lang=js"

import "./AlunosInativos.vue?vue&type=style&index=0&id=2e773dc8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e773dc8"]])

export default __exports__